import React, { useState } from "react";
import { Grid, IconButton, Tooltip, Typography, Divider } from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";

const OTActionMenu = ({
  title = "OT Master",
  showNew = false,
  showSave = false,
  showDelete = false,
  showExit = false,
  isEdit = false,
  onNew,
  onSave,
  onDelete,
  onExit,
  saveDisabled = false,
}) => {
  const [selectedButton, setSelectedButton] = useState(null);

  const handleClick = (action) => {
    setSelectedButton(action);
    if (action === "new" && onNew) onNew();
    if (action === "save" && onSave) onSave();
    if (action === "delete" && onDelete) onDelete();
    if (action === "exit" && onExit) onExit();
  };

  return (
    <Grid container justifyContent="space-between" alignItems="center" padding={1}>
      {/* Title */}
      <Grid item>
        <Typography variant="h5" sx={{ ml: 2 }}>
          {title}
        </Typography>
      </Grid>

      {/* Action Buttons */}
      <Grid item>
        <Grid container alignItems="center">
          {/* New */}
          {showNew && (
            <>
              <Tooltip title="Add New OT Master">
                <IconButton onClick={() => handleClick("new")}>
                  <AddCircleOutlineIcon
                    style={{
                      color: selectedButton === "new" ? "#ffb300" : "#4caf50",
                    }}
                  />
                  <Typography variant="body2" sx={{ ml: 0.5 }}>
                    New
                  </Typography>
                </IconButton>
              </Tooltip>
              <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
            </>
          )}

          {/* Save */}
          {showSave && (
            <>
              <Tooltip title={isEdit ? "Update OT Master" : "Save OT Master"}>
                <IconButton
                  onClick={() => handleClick("save")}
                  disabled={saveDisabled}
                >
                  <SaveAltIcon
                    style={{
                      color: selectedButton === "save" ? "yellow" : "#009688",
                    }}
                  />
                  <Typography variant="body2" sx={{ ml: 0.5 }}>
                    {isEdit ? "Update" : "Save"}
                  </Typography>
                </IconButton>
              </Tooltip>
              <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
            </>
          )}

          {/* Delete */}
          {showDelete && isEdit && (
            <>
              <Tooltip title="Delete OT Master">
                <IconButton onClick={() => handleClick("delete")}>
                  <DeleteIcon
                    style={{
                      color: selectedButton === "delete" ? "red" : "#f44336",
                    }}
                  />
                  <Typography variant="body2" sx={{ ml: 0.5 }}>
                    Delete
                  </Typography>
                </IconButton>
              </Tooltip>
              <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
            </>
          )}

          {/* Exit */}
          {showExit && (
            <Tooltip title="Exit">
              <IconButton onClick={() => handleClick("exit")}>
                <CloseIcon style={{ color: "#2196F3" }} />
                <Typography variant="body2" sx={{ ml: 0.5 }}>
                  Exit
                </Typography>
              </IconButton>
            </Tooltip>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default OTActionMenu;
